import { http } from '@/lib/axios';
import type { ApiSuccess, ListQueryParams, PaginatedResult } from '@/types/api';
import type { Notification, SendNotificationPayload } from '@/types/notification';
import { buildListParams } from '@/api/queryParams';

export const notificationsApi = {
  async list(params: ListQueryParams): Promise<PaginatedResult<Notification>> {
    const { data } = await http.get<ApiSuccess<Notification[]>>('/notifications', { params: buildListParams(params) });
    return { items: data.data, meta: data.meta! };
  },

  async unreadCount(): Promise<number> {
    const { data } = await http.get<ApiSuccess<{ unread_count: number }>>('/notifications/unread-count');
    return data.data.unread_count;
  },

  async markRead(id: number): Promise<void> {
    await http.patch(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<void> {
    await http.patch('/notifications/read-all');
  },

  async send(payload: SendNotificationPayload): Promise<Notification> {
    const { data } = await http.post<ApiSuccess<Notification>>('/admin/notifications', payload);
    return data.data;
  },
};
